import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { AFFILIATE_URL, trackRegisterClick } from '../utils/tracking';
type Variant = 'primary' | 'white' | 'onDark' | 'outline';
type Size = 'sm' | 'md' | 'lg';
interface CTAButtonProps {
  label: string;
  location: string;
  variant?: Variant;
  size?: Size;
  withIcon?: boolean;
  className?: string;
}
const SIZES: Record<Size, string> = {
  sm: 'h-10 px-5 text-[13px]',
  md: 'h-12 px-6 text-[14.5px]',
  lg: 'h-[52px] px-8 text-[15.5px] sm:h-14 sm:px-9 sm:text-base'
};
const VARIANTS: Record<Variant, string> = {
  primary: 'bg-brand-600 text-white hover:bg-brand-700 shadow-cta hover:shadow-lift',
  white: 'bg-white text-brand-800 hover:bg-brand-50 shadow-[0_14px_34px_-14px_rgba(0,0,0,0.55)]',
  onDark: 'border border-white/30 bg-white/[0.04] text-white hover:border-white/60 hover:bg-white/10',
  outline: 'border border-line bg-white text-ink-900 hover:border-brand-200 hover:text-brand-600'
};
export function CTAButton({
  label,
  location,
  variant = 'primary',
  size = 'md',
  withIcon = true,
  className = ''
}: CTAButtonProps) {
  return <a href={AFFILIATE_URL} target="_blank" rel="noopener noreferrer sponsored" onClick={() => trackRegisterClick(location, label)} className={`group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full font-semibold transition-[transform,background-color,border-color,box-shadow,color] duration-200 ease-expo hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.98] ${SIZES[size]} ${VARIANTS[variant]} ${className}`} data-id="element-37" data-mp="1db9ofs8vh5yq">
      {label}
      {withIcon && <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-expo group-hover:translate-x-1" aria-hidden="true" data-id="element-38" data-mp="210ugd0n07dk5" />}
    </a>;
}